import { useSyncExternalStore } from "react"

const MOBILE_BREAKPOINT = 768

const query = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

function getMql(): MediaQueryList | null {
  if (typeof window === "undefined") return null

  try {
    return window.matchMedia?.(query) ?? null
  } catch {
    return null
  }
}

function mediaQueryListener(callback: (event: MediaQueryListEvent) => void) {
  const mql = getMql()
  if (!mql) return () => undefined

  if (typeof mql.addEventListener === "function") {
    mql.addEventListener("change", callback)

    return () => {
      mql.removeEventListener("change", callback)
    }
  }

  mql.addListener(callback)

  return () => {
    mql.removeListener(callback)
  }
}

function isSmallerThanBreakpoint() {
  return getMql()?.matches ?? false
}

export function useIsMobile() {
  return useSyncExternalStore(
    mediaQueryListener,
    isSmallerThanBreakpoint,
    () => false,
  )
}
